import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requiredPermission, requireMaster }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-svh flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-gray-900 border-r-transparent"></div>
          <p className="mt-4 text-sm font-medium text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Protezione route riservate ai soli master
  if (requireMaster && user.role !== 'master') {
    return <Navigate to="/home" replace />;
  }

  // Verifica permessi se richiesti
  if (requiredPermission) {
    const hasPermission =
      user.role === 'master' ||
      (user.permissions && user.permissions.includes(requiredPermission));

    if (!hasPermission) {
      return <Navigate to="/home" replace />;
    }
  }

  return children;
}